import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/styles/index.css';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { ExtraErrorData } from '@sentry/integrations';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'index.css';

Sentry.init({
    dsn: 'https://decd3006c39142949808d42dc52e127b@o1060398.ingest.sentry.io/6055845',
    integrations: [new Integrations.BrowserTracing(), new ExtraErrorData({ depth: 5 })],
    normalizeDepth: 6,
    environment: process.env.REACT_APP_GIT_BRANCH,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
